import { useGetDeliveryCompanies } from "modules/deliveryCompanies";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { DateInput, FormField, Input, Select } from "ui";

import { NameFields, PasswordFields, PhoneField } from "../atoms";
import {
  MainInfoBlockProps,
  DriverFormValues
} from "../DriverDetailsForm.types";

import styles from "../DriverDetailsForm.module.scss";

export const MainInfoBlock = ({
  defaultValues: _defaultValues
}: MainInfoBlockProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext<DriverFormValues>();
  const { pathname } = useLocation();
  const isCompanyPortal = pathname.startsWith("/company");

  const today = new Date();

  const { companies, isLoading: isCompaniesLoading } = useGetDeliveryCompanies(
    {
      take: 100,
      skip: 0,
      isDeleted: false
    },
    { enabled: !isCompanyPortal }
  );

  const companyOptions = (companies ?? []).map((company) => ({
    label: company.name,
    value: company.id
  }));

  return (
    <div className={styles.driverForm__block}>
      <h4 className={styles.driverForm__block__title}>
        {t("Main Information")}
      </h4>

      <div className={styles.driverForm__block__box}>
        <NameFields control={control} />
        <Controller
          control={control}
          name={"birthdate"}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <DateInput
              value={value}
              onChange={onChange}
              label={t("Date of Birth")}
              errorMessage={error?.message}
              data-testid="driver--birthdate"
              maxDate={today}
            />
          )}
        />
        <PhoneField control={control} />
        <PasswordFields control={control} />
        <Controller
          control={control}
          name={"address"}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Input
              value={value}
              onChange={onChange}
              label={t("Address")}
              errorMessage={error?.message}
              data-testid="driver--address"
              maxLength={150}
            />
          )}
        />
        {!isCompanyPortal && (
          <Controller
            control={control}
            name={"deliveryCompanyId"}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <FormField
                label={t("Delivery Company")}
                errorMessage={error?.message}
              >
                <Select
                  value={value ?? ""}
                  placeholder={t("Independent driver")}
                  isOptionsLoading={isCompaniesLoading}
                  options={[
                    { label: t("Independent driver"), value: "" },
                    ...companyOptions
                  ]}
                  onChange={(next) => {
                    const picked = Array.isArray(next) ? next[0] : next;
                    onChange(picked || null);
                  }}
                />
              </FormField>
            )}
          />
        )}
      </div>
    </div>
  );
};
